const startingAnimation = () => {

let mainURL_EN = document.location.protocol + '//' + document.location.host + '/',
	mainURL_RU = document.location.protocol + '//' + document.location.host + '/ru';

	//если находимся на главной странице
	if (document.location.href == mainURL_EN || document.location.href == mainURL_RU) {
		let inactivityTime = () => {
		  let time,
		  	  main = document.querySelectorAll('.main'),
			  animationDesctop = document.querySelector('.animation-desctop');
		  	
		  document.addEventListener('mousemove', resetTimer);
		  document.addEventListener('keypress', resetTimer);

		  function resetTimer() {
		    animationDesctop.classList.add('hide');	    
		    clearTimeout(time);
		    time = setTimeout(fn, 1000);
		  }

		  function fn() {
		    animationDesctop.classList.remove('hide');	    
		  }
		};
		inactivityTime();	
	}

	
}
export default startingAnimation;